import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { SvgIcon } from "../../atoms/SvgIcon";

const useStyles = makeStyles({
	root: {
		width: "2.5rem",
		height: "100%",
	},
});

const HamburgerMenuIcon = () => {
	const styles = useStyles();

	return (
		<SvgIcon viewBox={"0 0 40 40"} className={styles.root} color={"primary"}>
			<g fill='none' fillRule='evenodd'>
				<path fill='none' d='M0 0h40v40H0z' />
				<path
					stroke='#3D405B'
					strokeWidth='2'
					strokeLinecap='round'
					d='M4.5 15H11M4.5 20h30M4.5 25h30'
				/>
				<path
					d='M15.803 16a.087.087 0 0 0 .063-.026.087.087 0 0 0 .027-.064v-3.023c0-.02.005-.03.014-.03.01 0 .02.008.03.023l.653 1.042c.02.04.055.06.105.06h.532c.05 0 .085-.02.105-.06l.645-1.035c.01-.014.02-.022.03-.022.01 0 .015.01.015.03v3.015c0 .025.01.046.027.064a.087.087 0 0 0 .064.026h1.064a.087.087 0 0 0 .064-.026.087.087 0 0 0 .026-.064v-5.07a.087.087 0 0 0-.026-.064.087.087 0 0 0-.064-.026H18.12c-.05 0-.085.02-.105.06l-1.027 1.635c-.015.03-.03.03-.046 0L15.9 10.81a.118.118 0 0 0-.105-.06h-1.057a.087.087 0 0 0-.064.026.087.087 0 0 0-.026.064v5.07c0 .025.008.046.026.064a.087.087 0 0 0 .064.026h1.065zm8.437 0a.087.087 0 0 0 .064-.026.087.087 0 0 0 .026-.064v-.885a.087.087 0 0 0-.026-.064.087.087 0 0 0-.064-.026h-2.355c-.025 0-.038-.013-.038-.037v-.99c0-.025.013-.038.038-.038h1.507a.087.087 0 0 0 .064-.026.087.087 0 0 0 .027-.064v-.877a.087.087 0 0 0-.027-.064.087.087 0 0 0-.064-.027h-1.507c-.025 0-.038-.012-.038-.037v-.923c0-.024.013-.037.038-.037h2.355a.087.087 0 0 0 .064-.026.087.087 0 0 0 .026-.064v-.885a.087.087 0 0 0-.026-.064.087.087 0 0 0-.064-.026h-3.547a.087.087 0 0 0-.064.026.087.087 0 0 0-.027.064v5.07c0 .025.01.046.027.064a.087.087 0 0 0 .063.026h3.548zm2.445 0a.087.087 0 0 0 .064-.026.087.087 0 0 0 .026-.064l-.008-2.82c0-.02.006-.031.015-.034.01-.002.02.004.03.019l1.726 2.865c.02.04.055.06.104.06h1.02a.087.087 0 0 0 .064-.026.087.087 0 0 0 .027-.064v-5.07a.087.087 0 0 0-.027-.064.087.087 0 0 0-.063-.026h-1.066a.087.087 0 0 0-.063.026.087.087 0 0 0-.026.064l.007 2.813c0 .02-.005.03-.015.033-.01.003-.02-.004-.03-.018l-1.717-2.858c-.02-.04-.055-.06-.105-.06H25.62a.087.087 0 0 0-.064.026.087.087 0 0 0-.026.064v5.07c0 .025.009.046.026.064a.087.087 0 0 0 .064.026h1.065zm6.383.06c.395 0 .743-.076 1.046-.229.302-.152.536-.368.701-.649a1.87 1.87 0 0 0 .248-.967V10.84a.087.087 0 0 0-.027-.064.087.087 0 0 0-.064-.026h-1.065a.087.087 0 0 0-.063.026.087.087 0 0 0-.026.064v3.375c0 .235-.07.424-.207.566a.721.721 0 0 1-.543.214c-.23 0-.414-.071-.552-.214-.137-.142-.206-.331-.206-.566V10.84a.087.087 0 0 0-.026-.064.087.087 0 0 0-.064-.026h-1.065a.087.087 0 0 0-.064.026.087.087 0 0 0-.026.064v3.375c0 .365.084.688.251.967.168.28.403.497.705.65.303.152.651.228 1.047.228z'
					fill='#3D405B'
					fillRule='nonzero'
				/>
			</g>
		</SvgIcon>
	);
};

export { HamburgerMenuIcon };
